<template>
  <div class="product-header-images">
    <div class="main-image">
      <div class="zoom" v-show="showzoom" v-on:mouseover="showZoom" v-on:mouseleave="hideZoom">
        <i class="icon icon-search" @click="showModal"></i>
      </div>
      <img
        class="main"
        :src="mainImage || slides[mainImageIndex].mediaUrl"
        :alt="productTitle"
        @click="showModal"
        v-on:mouseover="showZoom"
        v-on:mouseleave="hideZoom"
      />
      <div v-if="isNewProduct" class="__new-product">
        <p>{{ label_new_product_new }}</p>
      </div>
      <div v-if="isOnSaleProduct" class="__sale-product">
        <p>{{ label_on_sale_product }}</p>
      </div>
      <div v-if="isSaleProduct" :class="sale_corner_style">
        <p>{{ label_sale_product }}</p>
      </div>
      <div class="badges-wrapper">
        <!-- isBadgeActive(BadgeID) it checks the badges array to decide whether the id is included or not -->
        <div v-if="isBadgeActive(3)" class="reddot-2021-badge">
          <img src="https://assets.rhinorack.com/Images/Badges/reddot-winner-2021-transparent.png" alt="reddot 2021 badge" />
        </div>
        <div v-if="isBadgeActive(1)" class="ausmade-badge" >
          <img src="https://assets.rhinorack.com/Images/Badges/ausmade.png" alt="australian made badge" />
        </div>
        <div v-if="isBadgeActive(2)" class="good-design-award-badge">
          <img src="https://assets.rhinorack.com/Images/Badges/good-design-award-highres.png" alt="good design award badge" />
        </div>
        <div v-if="isBadgeActive(5)" class="zwifloc-included-badge">
          <img src="https://assets.rhinorack.com/zwifloc/Stow-it-Badge.svg" alt="zwifloc included badge" />
        </div>
      </div>

      <div class="pioneer-badge-wrapper">
        <div v-if="isBadgeActive(6)" class="pioneer-product-badge">
          <img src="https://assets.rhinorack.com/Images/Badges/ausmade.png" alt="Pioneer badge" />
        </div>
      </div>
    </div>
    <div
      :class="hasFilmbox ? 'owl-carousel product-header-slider filmboxer' : 'owl-carousel product-header-slider'"
      id="product-header-slider"
    >
      <div class="item-wrapper" v-for="(slide, index) in slides" :key="index" :style="{ 'border-radius' : is3DSlide(slide) ? '6px' : 'inherit', 'border-color': is3DSlide(slide) ? '#f4c44d91' : 'none' }">
        <div class="item" :style="{ 'background-color' : is3DSlide(slide) ? 'transparent' : 'none' }">
          <img v-if="slide.mediaUrl && slide.contentType == 1" :src="slide.mediaUrl" :alt="productTitle + ' - Stock Code: ' + productStockCode"
          @click="setMainImage(slide.id, slide.mediaUrl, index)" />
          <img v-if="(slide.mediaUrl && is3DSlide(slide))" :src="slide.mediaUrl" :alt="productTitle + ' - Stock Code: ' + productStockCode"
          @click="setMainImage(slide.id, slide.mediaUrl, index)" :style="{ 'border-radius' : is3DSlide(slide) ? '5px' : 'none' }"/>
          <div @click="openVideoModal(slide)" v-if="slide.embedCode && (slide.contentType == 2)"
              v-bind:style="{ 'background-image': 'url(' + getVideoThumbnail(slide) + ')' }" class="video-slide">
            <div class="overlay-dark"></div>
            <img src="/cdn/images/owl.video.play.png" id="play-btn" alt="play button" style="z-index:3">
          </div>
          <div v-if="isNewProduct" class="__new-product">
        <p>{{ label_new_product_new }}</p>
      </div>
      <div v-if="isOnSaleProduct" class="__sale-product">
        <p>{{ label_on_sale_product }}</p>
      </div>
      <div v-if="isSaleProduct" :class="sale_corner_style">
        <p>{{ label_sale_product }}</p>
      </div>

        </div>
              <div class="badges-wrapper">
        <!-- isBadgeActive(BadgeID) it checks the badges array to decide whether the id is included or not -->
        <div v-if="isBadgeActive(3)" class="reddot-2021-badge">
          <img src="https://assets.rhinorack.com/Images/Badges/reddot-winner-2021-transparent.png" alt="reddot 2021 badge" />
        </div>
        <div v-if="isBadgeActive(1)" class="ausmade-badge" >
          <img src="https://assets.rhinorack.com/Images/Badges/ausmade.png" alt="australian made badge" />
        </div>
        <div v-if="isBadgeActive(2)" class="good-design-award-badge">
          <img src="https://assets.rhinorack.com/Images/Badges/good-design-award-highres.png" alt="good design award badge" />
        </div>
        <div v-if="isBadgeActive(5)" class="zwifloc-included-badge">
          <img src="https://assets.rhinorack.com/zwifloc/Stow-it-Badge.svg" alt="zwifloc included badge" />
        </div>
      </div>
      </div>
    </div>
    <modal name="image-modal" :adaptive="true" width="80%" height="80%" :scrollable="true" class="product-modal-image">
      <i class="icon icon-close" @click="$modal.hide('image-modal')"></i>
      <i class="icon icon-left" @click="changeSlide('back')"></i>
      <i class="icon icon-right" @click="changeSlide('forward')"></i>
      <img
        v-if="this.isNumeric(mainImageIndex)"
        class="modal-image"
        :src="slides[mainImageIndex].mediaUrl"
      />
    </modal>

    <modal name="filmbox-modal" :adaptive="true" width="80%" height="80%" :scrollable="true">
      <i class="icon icon-close" @click="handleResize()"></i>
      <iframe
        id="fileboxIframe"
        ref="fileboxIframe"
        style="width:100%; height: 100%"
        :src="this.filmboxurl"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </modal>
      <div v-if="isBadgeActive(4)" class="stow-it-badge">
        <img src="https://assets.rhinorack.com/StowIt/Stow-it-badge.svg" alt="stow it badge" />
      </div>

    <modal name="youtube-modal" :adaptive="true" width="80%" height="80%" :scrollable="true" style="display:flex;justify-content:center; align-items:center;">
        <iframe  v-if="youtubeURL" width="100%" height="100%" :src="youtubeURL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="false"></iframe>
    </modal>
  </div>
</template>

<script>
export default {
  name: "product-header-slider",
  props: {
    data: Array,
    is_new_product: String,
    is_on_sale_product: String,
    is_sale_product: String,
    sale_corner_text: String,
    sale_corner_style: String,
    badge_type: String,
    filmboxurl: String,
    productTitle: String,
    productStockCode: String,
    components: {
      type: Array
    },
    label_new_product_new: {
      type: String,
      required: true,
      default: "New",
    },
    label_on_sale_product: {
      type: String,
      required: true,
      default: "SALE",
    },
    price: {
      type: Number,
      required: true
    },
    category: {
      type: Object
    },
    item_brand: {
      type: String,
      default: "Rhinorack"
    },
    ga_tracking_category: {
      type: String,
      default: "view_item"
    },
  },
  data() {
    return {
      owl: null,
      mainImage: false,
      mainImageIndex: 0,
      showzoom: false,
      hasFilmbox: false,
      fileboxBucket: null,
      currency: window.currency,
      culture: window.culture,
      country: window.country,
      product_category: '',
      owloptions: {
        responsive: {
          0: {
            items: 1,
            nav: false,
            dots: true,
          },
          992: {
            items: 4,
            nav: true,
            dots: false,
          },
        },
      },
      youtubeURL: null,
    };
  },
  created() {
    this.setMainImageIndexStart();
  },
  mounted() {
    this.owl = $("#product-header-slider");

    this.owl.owlCarousel(this.owloptions);

    if (this.owl.data("owl.carousel").settings.items == 1) {
      if (this.hasFilmbox && !this.fileboxBucket) {
        this.fileboxBucket = this.slides[1];
        // this.slides.shift();
        this.owl
          .trigger("remove.owl.carousel", 1)
          .trigger("refresh.owl.carousel");
      }
    }

    window.addEventListener("resize", this.handleResize);
    this.filterCategory();
  },
  computed: {
    isNewProduct() {
      return this.is_new_product === "1" ? true : false;
    },
    isOnSaleProduct() {
      return this.is_on_sale_product === "1" ? true : false;
    },
    isSaleProduct() {
      return this.is_sale_product === "1" ? true : false;
    },
    label_sale_product() {
      return this.sale_corner_text;
    },
    slides() {
      return this.data;
    },
  },
  methods: {
    filterCategory(){
          
        this.product_category = this.category?.title || "";
        
        const item_id = this.components && this.components.length === 0 ? this.productStockCode : this.productStockCode + 'N';

          setTimeout(()=>{
            gtag('event', this.ga_tracking_category, {
              "currency": this.currency,
              "value": this.price,
              "items": [
                {
                  "item_id": item_id,
                  "item_name": item_id,
                  "item_brand": this.item_brand,
                  "item_category": this.product_category,
                  "price": this.price
                }
              ]
            });
          }, 500);
    },
   isNumeric: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },
    handleResize() {
      this.$modal.hide("filmbox-modal");
    },
    setMainImageIndexStart() {
      this.mainImageIndex = this.slides.findIndex((slide) => slide.id > 1);
      this.hasFilmbox = this.filmboxurl ? true : false;
    },
    setMainImage(id, src, index) {
      if (id) {
        this.mainImage = src;
        this.mainImageIndex = index;
      } else {
        // this is the 3d modal
        this.$modal.show("filmbox-modal");
        ga('send', 'event','3D Image','Click', src);
            gtag('event', '3d_image', {'category':'3D Image', 'action':'Click', 'value': src});
      }
    },
    showZoom() {
      this.showzoom = true;
    },
    hideZoom() {
      this.showzoom = false;
    },
    showModal() {
      this.$modal.show("image-modal");
    },
    changeSlide(direction) {
      this.setMainImageIndex(direction);

      if (this.slides[this.mainImageIndex].embedCode || this.slides[this.mainImageIndex].contentType == 3) {
        this.changeSlide(direction);
      }

      if (!this.slides[this.mainImageIndex].id) {
        this.setMainImageIndex(direction);
      }

      this.mainImage = this.slides[this.mainImageIndex].mediaUrl;
    },
    setMainImageIndex(direction) {
      direction === "back"
        ? (this.mainImageIndex -= 1)
        : (this.mainImageIndex += 1);

      if (this.mainImageIndex < 0) {
        this.mainImageIndex = this.slides.length - 1;
      }

      if (this.mainImageIndex == this.slides.length) {
        this.mainImageIndex = 0;
      }
    },
    isBadgeActive(id) {
      let badges = this.badge_type.split(',').map(Number);
      return badges.includes(id);
    },
    openVideoModal(slide) {
      this.youtubeURL = "https://www.youtube.com/embed/" + slide.embedCode + '?rel=0';
      this.$modal.show("youtube-modal");
      ga('send', 'event', 'YouTube Videos', this.productStockCode + ' - ' +  slide.embedCode);
      gtag('event', 'youtube_video', {'category':'Youtube Video', 'action':this.productStockCode + ' - ' +  slide.embedCode});
    },
    getVideoThumbnail(slide) {
      return (slide && slide.mediaUrl) ? slide.mediaUrl : `https://i.ytimg.com/vi/${slide.embedCode}/0.jpg`;
    },
     is3DSlide(slide) {
      return slide.contentType == 3;
    }
  },
};
</script>
<style lang="scss">
.product-header-images{
  overflow-x: hidden;
}
.product-modal-image{
  overflow: hidden;
}

.product-modal-image .v--modal-box.v--modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.filmboxer > div.owl-stage-outer > div > div:nth-child(1) {
  visibility: visible;
}

// @media only screen and (max-width: 900px) {
//   .filmboxer > div.owl-stage-outer > div > div:nth-child(1) {
//     visibility: hidden;
//   }
// }

.product-header-images .main-image img.main {
  cursor: pointer;
  cursor: hand;
}
.product-header-images .main-image .zoom {
  position: absolute;
  z-index: 1;
  background: #fff;
  width: 40px;
  height: 40px;
  padding: 0 7px;
  top: 50%;
  left: 50%;
  margin: -20px 0 0 -20px;
  color: #cecece;
  cursor: hand;
  cursor: pointer;
  font-size: 25px;
  border: 1px solid #cecece;
}
.v--modal-overlay {
  z-index: 1000000;
}
/* .v--modal-overlay .v--modal-box {
  height: auto !important;
} */
.v--modal-overlay .v--modal-box i.icon.icon-left,
.v--modal-overlay .v--modal-box i.icon.icon-right {
  position: absolute;
  top: 50%;
  margin-top: -12.5px;
  cursor: hand;
  cursor: pointer;
  background-color: #fff;
  padding: 5px;
  opacity: 0.75;
  border-radius: 5px;
}
.v--modal-overlay .v--modal-box i.icon.icon-left {
  left: 12.5px;
}
.v--modal-overlay .v--modal-box i.icon.icon-right {
  right: 12.5px;
}
.v--modal-overlay .v--modal-box i.icon.icon-close {
  position: absolute;
  right: 5px;
  top: 10px;
  background: #fff;
  padding: 10px;
  cursor: hand;
  cursor: pointer;
}

.badges-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -10px;
    left: -10px;
    z-index: 1;
    margin: 0px 0px 10px 15px;
}
.badges-wrapper div {
   display: flex;
   justify-content: center;
    width: 75px;
    height: 75px;
    padding: .5rem;
}

.pioneer-badge-wrapper{
  position: absolute;
  bottom: 0;
  right: 0;

  div.pioneer-product-badge{
    height: 93px;
    width: 90px;

    @media screen and (max-width:500px){
        height: 60px;
    }
  }
  
}

  div.good-design-award-badge {
    height: 78px;
    width: 120px;
    
    @media screen and (max-width:500px){
        height: 60px;
    }

  }
  div.zwifloc-included-badge {
    height: 78px;
    width: 120px;

    @media screen and (max-width:500px){
        height: 60px;
    }


  }


  div.reddot-2021-badge {
    height: 78px;
    width: 130px;

    @media screen and (max-width:500px){
        height: 70px;
    }

  }

  div.stow-it-badge {
    position: absolute;
    top: .5rem;
    left: 1.5rem;
    z-index: 1;
  }

  div.stow-it-badge img {
    height: 60px;

    @media screen and (max-width:500px){
        height: 40px;
    }

  }

  @media screen and (min-width:992px){
    .product-header-images .product-header-slider .item-wrapper .badges-wrapper {
        display: none;
    }

  }
  @media screen and (min-width:992px) {
    #product-header-slider .item-wrapper .__new-product{
      display: none;
    }
  }


.owl-nav .owl-prev.disabled,
.owl-nav .owl-next.disabled {
  visibility: hidden;
}
.video-slide {
  display:flex;
  justify-content: center;
  align-items:center;
  height:100%;
  background-size: cover;
  position: relative;
  background-position: center;
  cursor: pointer;
  background-color: white;

  img#play-btn {
    width:50%;
    padding:.4rem
  }
}
.overlay-dark {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
  }

</style>


